import React from 'react';
import { Button, CircularProgress, ButtonProps } from '@mui/material';

export interface LoadingButtonProps extends ButtonProps {
  loading?: boolean;
  loadingPosition?: 'start' | 'end';
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  loading = false,
  loadingPosition = 'start',
  children,
  startIcon,
  endIcon,
  disabled,
  ...rest
}) => {
  const spinner = <CircularProgress size={18} color="inherit" />;
  const resolvedStartIcon = loadingPosition === 'start' && loading ? spinner : startIcon;
  const resolvedEndIcon = loadingPosition === 'end' && loading ? spinner : endIcon;
  return (
    <Button disabled={loading || disabled} startIcon={resolvedStartIcon} endIcon={resolvedEndIcon} {...rest}>
      {children}
    </Button>
  );
};

export default LoadingButton;
